import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './qr-collapsible-section.module.scss';
import type {QRCollapsibleSectionProps} from './qr-collapsible-section.types';

export function QRCollapsibleSection({label, children}: QRCollapsibleSectionProps): ReactElement {
  return (
    <details className={styles.qrCollapsibleSection}>
      <summary className={styles.qrCollapsibleSummary}>
        <Text val={label} size={TextSize.MD} bold />
        <Icon icon="icon-caret-down" size={IconSize.SIZE_ICON_16} className={styles.qrCollapsibleCaret} ariaHidden />
      </summary>
      <div className={styles.qrCollapsibleBody}>{children}</div>
    </details>
  );
}
